// extracted by mini-css-extract-plugin
module.exports = {"QuestionBox":"style_QuestionBox__1BiMW","content":"style_content__1O856","title":"style_title__3Sb7j","text":"style_text__WxF23","button":"style_button__2JcN7"};